<template>
  <div class="">
    <BasiceLayout
      :title=" $t('device_overview') "
      class="bonus-code-layout revenue-all-layout"
    >
      <div class="BasicInput">
        <div class="revenueWrap top_total_revenue">
          <!-- 账号总数 -->
          <div class="one_day_revenue each_item_wrap ">
            <div class="revenue_item">
              <div class="revenue_title">{{ $t('account_device_count') }}</div>
            </div>
            <div
              class="revunue_value"
              v-if="overview.total !== ''"
            >{{overview.total || 0}} {{ $t('num') }}
              <span
                  v-if="overview.total !== '' && overview.total !== 0"
                  class="bonus-cursor overview-show-detail"
                  @click="showDetail('all')"
                >{{ $t('showDetail') }}</span>
            </div>
            <div
              class="revunue_value"
              v-if="overview.total === ''"
            >-</div>
          </div>
          <!-- 网络设备正常总数 -->
          <div class="one_day_invite_revenue each_item_wrap">
            <div class="revenue_item">
              <div class="revenue_title">{{ $t('normalNetworkNum') }}
              </div>
            </div>
            <div
              class="revunue_value"
              v-if="overview.network_normal !== ''"
            >{{ overview.network_normal || 0 }} {{ $t('num') }}
              <span
                v-if="overview.network_normal !== '' && overview.network_normal !== 0"
                class="bonus-cursor overview-show-detail"
                @click="showDetail('networkNormal')"
              >{{ $t('showDetail') }}</span></div>
            <div
              class="revunue_value"
              v-if="overview.network_normal === ''"
            >-</div>
          </div>
          <!-- 计算设备正常总数 -->
          <div class="total_revenue each_item_wrap">
            <div class="revenue_item">
              <div class="revenue_title">{{ $t('normalCalculateNum')}}
              </div>
            </div>
            <div
              class="revunue_value"
              v-if="overview.compute_normal !== ''"
            >{{ overview.compute_normal  || 0}} {{ $t('num') }}
              <span
                v-if="overview.network_normal !== '' && overview.network_normal !== 0"
                class="bonus-cursor overview-show-detail"
                @click="showDetail('calculateNormal')"
              >{{ $t('showDetail') }}</span>
            </div>
            <div
              class="revunue_value"
              v-if="overview.compute_normal=== ''"
            >- </div>
          </div>
        </div>
      </div>
    </BasiceLayout>
    <!-- 网络故障 -->
    <BasiceLayout
      :title=" $t('network_error_title') "
      class="bonus-code-layout revenue-all-layout overview-layout"
    >
      <div class="BasicInput">
        <div class="revenueWrap">
          <!-- 离线设备 -->
          <div class="one_day_invite_revenue each_item_wrap">
            <div class="revenue_item">
              <div class="revenue_title">{{ $t('offlineDevice') }}</div>
            </div>
            <div
              class="revunue_value"
              v-if="overview.network_offline !== ''"
            >{{ overview.network_offline || 0}} {{ $t('num') }} <span
                v-if="overview.network_offline !== '' && overview.network_offline !== 0"
                class="bonus-cursor overview-show-detail"
                @click="showDetail('offline')"
              >{{ $t('showDetail') }}</span> </div>
            <div
              class="revunue_value"
              v-if="overview.network_offline === ''"
            >-</div>
          </div>
          <!-- 网络资源不可用 -->
          <div class="total_revenue each_item_wrap">
            <div class="revenue_item">
              <div class="revenue_title">{{ $t('usableNet')}}
              </div>
            </div>
            <div
              class="revunue_value"
              v-if="overview.network_bad !== ''"
            >{{ overview.network_bad  || 0}} {{ $t('num') }} <span
                v-if="overview.network_bad !== '' && overview.network_bad !== 0"
                class="bonus-cursor overview-show-detail"
                @click="showDetail('usableNet')"
              >{{ $t('showDetail') }}</span> </div>
            <div
              class="revunue_value"
              v-if="overview.stable_high === ''"
            >-</div>
          </div>
          <div class="one_day_revenue each_item_wrap">
          </div>
        </div>
      </div>
    </BasiceLayout>
    <!-- 计算故障 -->
    <BasiceLayout
      :title=" $t('calcute_error_title') "
      class="bonus-code-layout revenue-all-layout overview-layout"
    >
      <div class="BasicInput">
        <div class="revenueWrap top_total_revenue">
          <!-- 不可调度 -->
          <div class="one_day_invite_revenue each_item_wrap">
            <div class="revenue_item">
              <div class="revenue_title">{{ $t('failedScheduling') }}</div>
            </div>
            <div
              class="revunue_value"
              v-if="overview.compute_unsche !== ''"
            >{{ overview.compute_unsche || 0}} {{ $t('num') }} <span
                v-if="overview.compute_unsche !== '' && overview.compute_unsche !== 0"
                class="bonus-cursor overview-show-detail"
                @click="showDetail('unschedule')"
              >{{ $t('showDetail') }}</span> </div>
            <div
              class="revunue_value"
              v-if="overview.compute_unsche === ''"
            >-</div>
          </div>
          <!-- 内存小于1G -->
          <div class="total_revenue each_item_wrap">
            <div class="revenue_item">
              <div class="revenue_title">{{ $t('lowMem')}}
              </div>
            </div>
            <div
              class="revunue_value"
              v-if="overview.compute_lowmem !== ''"
            >{{ overview.compute_lowmem  || 0}} {{ $t('num') }} <span
                v-if="overview.compute_lowmem !== '' && overview.compute_lowmem !== 0"
                class="bonus-cursor overview-show-detail"
                @click="showDetail('lowMem')"
              >{{ $t('showDetail') }}</span> </div>
            <div
              class="revunue_value"
              v-if="overview.compute_lowmem === ''"
            >-</div>
          </div>
          <!-- 硬盘小于100G -->
          <div class="one_day_revenue each_item_wrap">
            <div class="revenue_item">
              <div class="revenue_title">{{ $t('lowStorage') }}
              </div>
            </div>
            <div
              class="revunue_value"
              v-if="overview.compute_lowhd !==''"
            >{{overview.compute_lowhd || 0}} {{ $t('num') }} <span
                v-if="overview.compute_lowhd !== '' && overview.compute_lowhd !== 0"
                class="bonus-cursor overview-show-detail"
                @click="showDetail('lowStorage')"
              >{{ $t('showDetail') }}</span></div>
            <div
              class="revunue_value"
              v-if="overview.compute_lowhd === ''"
            >-</div>
          </div>
        </div>
        <div class="revenueWrap">
          <!-- 调度状态 -->
          <div class="one_day_invite_revenue each_item_wrap">
            <div class="revenue_item">
              <div class="revenue_title">{{ $t('scheduleStatusFailed') }}</div>
            </div>
            <div
              class="revunue_value"
              v-if="overview.compute_untask !== ''"
            >{{ overview.compute_untask || 0}} {{ $t('num') }} <span
                v-if="overview.compute_untask !== '' && overview.compute_untask !== 0"
                class="bonus-cursor overview-show-detail"
                @click="showDetail('unTask')"
              >{{ $t('showDetail') }}</span> </div>
            <div
              class="revunue_value"
              v-if="overview.compute_untask === ''"
            >-</div>
          </div>
          <div class="total_revenue each_item_wrap">
            <div class="revenue_item">
              <div class="revenue_title">无带宽数据
              </div>
            </div>
            <div
              class="revunue_value"
              v-if="overview.compute_no_monitor !== ''"
            >{{ overview.compute_no_monitor  || 0}} {{ $t('num') }} <span
                v-if="overview.compute_no_monitor !== '' && overview.compute_no_monitor !== 0"
                class="bonus-cursor overview-show-detail"
                @click="showDetail('NoMonitor')"
              >{{ $t('showDetail') }}</span> </div>
            <div
              class="revunue_value"
              v-if="overview.compute_no_monitor === ''"
            >-</div>
          </div>
          <div class="one_day_revenue each_item_wrap">
          </div>
        </div>
      </div>
    </BasiceLayout>
  </div>
</template>

<script>
import BasiceLayout from "@/components/Common/BasicLayout.vue";
import RevenueContent from "@/components/DatePanel/RevenueContent.vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "BonusCode",
  components: {
    BasiceLayout,
    RevenueContent
  },
  computed: mapState({
    overview: state => state.device.overview || "",
    currentPage: state => state.hardWare.currentPage,
    filterType: state => state.device.filterType,
    currentPage: state => state.hardWare.currentPage
  }),

  methods: {
    ...mapActions(["getDeviceOverview", "getHardList", "setFiltertype"]),
    showDetail(filterType) {
      this.setFiltertype(filterType);
      this.getHardList({ filterType, pageNum: 1 });
    }
  },
  created() {
    this.getDeviceOverview();
  }
};
</script>

<i18n>
{
  "en": {
		"device_overview": "Device Overview",
    "normalNetworkNum": "Running Network Device",
    "normalCalculateNum": "Running Compute Device",

    "network_error_title": "Network Error",
    "calcute_error_title": "Compute Error",
    "offlineDevice": "Offline Device",
    "usableNet": "Network Usable",

    "failedScheduling": "Compute Resources Unschedulable",
    "lowMem": "Low Memory",
    "lowStorage": "Low Storage",
    "num": " ",
    "showDetail": "Details",
    "scheduleStatusFailed": "Scheduling Failed",
    "account_device_count": "Total Device"

  },
  "zn": {
    "device_overview": "设备总览",	
    "normalNetworkNum": "网络任务正常设备数",
    "normalCalculateNum": "计算任务正常设备数",
    "network_error_title": "网络故障",
    "calcute_error_title": "计算故障",
    "offlineDevice": "离线设备",
    "usableNet": "网络资源不可用",
    "failedScheduling": "计算任务资源不可调度",
    "lowMem": "内存小于1G",
    "lowStorage": "硬盘小于100G",
    "num": "台",
    "showDetail": "查看详情",
    "scheduleStatusFailed": "调度失败",
    "account_device_count": "账号设备总数"
  }
}


</i18n>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
.revenue-all-layout {
  margin-top: 0px;
}

.revenue-all-layout .layout-content {
  margin: 0;
}

.overview-show-detail {
  font-size: 13px;
  color: #13b8bc;
  margin-left: 10px;
}

.overview-layout {
  margin-top: 20px;
}
</style>
